import React from "react";
import browse1 from "../../assets/images/browse1.svg";
import browse2 from "../../assets/images/browse2.svg";
import browse3 from "../../assets/images/browse3.svg";
import browse4 from "../../assets/images/browse4.svg";
import browse5 from "../../assets/images/browse5.svg";
import browse6 from "../../assets/images/browse6.svg";
import browse7 from "../../assets/images/browse7.svg";
import browse9 from "../../assets/images/browse8.svg";
import browse10 from "../../assets/images/browse1.svg";
interface Category {
  name: string;
  icon: string; // Use your icons here
  jobsAvailable: number;
}

const categories: Category[] = [
  { name: "Retail & Product", icon: browse1, jobsAvailable: 2 },
  { name: "Content Writer", icon: browse2, jobsAvailable: 3 },
  { name: "Human Resource", icon: browse3, jobsAvailable: 2 },
  { name: "Market Research", icon: browse4, jobsAvailable: 2 },
  { name: "Retail & Product", icon: browse1, jobsAvailable: 2 },
  { name: "Software", icon: browse5, jobsAvailable: 1 },
  { name: "Finance", icon: browse6, jobsAvailable: 3 },
  { name: "Management", icon: browse7, jobsAvailable: 3 },
  { name: "Marketing & Sale", icon: browse9, jobsAvailable: 2 },
  { name: "Software", icon: browse10, jobsAvailable: 1 },
];

const CategoryCards: React.FC = () => (
  <section className="bg-[#EAF0F6] font-manrope ">
    <div className="max-w-7xl mx-auto lg:px-6 md:px-12 px-4 xl:py-20 lg:py-16 py-10 ">
      <h2 className="xl:text-5xl md:text-4xl text-3xl text-center font-extrabold text-[#0E313A] mb-3">
        Browse by category
      </h2>
      <p className="text-center text-[#6C757D] text-[16px] mb-10">
        Find the job that's perfect for you. About 800+ new jobs everyday
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
        {categories.map((category, idx) => (
          <div key={idx} className="flex gap-2 items-center bg-white rounded-xl shadow p-4">
            <img src={category.icon} alt="icon" className="h-10"/>
           <div className="flex flex-col gap-1">
             <div className="font-extrabold text-[#05264E]">{category.name}</div>
            <div className="text-sm font-semibold text-[#4F5E64] ">
              {category.jobsAvailable} Jobs Available
            </div>
          </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CategoryCards;
